import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CloseIcon, TrashIcon } from '../assets/icons';
import { formatMiles, fromPhotos } from '../utils';

const Cart = ({ onClose }) => {
  const { cart, getPrice, removeItem, submit } = useCart(onClose);

  return (
    <div className="w-full sm:w-[32rem] bg-white px-4 pt-2 pb-4 rounded-xl">
      <div className="flex justify-between items-center">
        <h1 className="font-semibold text-lg text-blue">Mi Pedido</h1>

        <button
          className="flex items-center gap-2"
          onClick={() => onClose()}
        >
          <img src={CloseIcon} className="w-3 h-3 object-contain" alt="" />
        </button>
      </div>

      <div className="my-6 flex flex-col gap-2">
        {cart.map((item, index) => {
          const price = getPrice(item);
          return (
            <div key={index} className="flex justify-between gap-2 border-b border-b-gray6 pb-4">
              <div className="flex gap-2 items-start">
                <div className="w-10 h-10 flex justify-center items-center">
                  <img src={fromPhotos(item.photo)} className="w-10 h-10 object-cover rounded-lg" alt="" />
                </div>
                <div>
                  <p className="text-lg font-bold text-darkBlue">{ item.name }</p>
                  <p>Cuotas: { item?.fees }</p>
                  <p className="text-xl font-bold text-darkBlue">{ formatMiles(price, !Number.isInteger(parseFloat(price))) }</p>
                </div>
              </div>
              <div>
                <button onClick={() => removeItem(index)}>
                  <img src={TrashIcon} className="w-8 h-8 object-contain" alt="" />
                </button>
              </div>
            </div>
          )
        })}

        {!cart?.length && (
          <div className="my-4">
            <p className="text-center text-sm text-gray2">
              No tienes productos en tu carrito
            </p>
          </div>
        )}
      </div>

      <div className="flex justify-center">
        <button
          className="mt-2 rounded-lg w-1/3 text-center h-10 bg-green font-bold text-white disabled:bg-gray6 disabled:text-gray3"
          onClick={submit}
          disabled={!cart?.length}
        >
          <span>Pagar</span>
        </button>
      </div>
    </div>
  )
}

const useCart = (onClose) => {
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const history = useHistory();

  const getPrice = (item) => {
    if (item?.is_deductible_based) {
      if (item?.selectedDeductible) {
        // Busca el precio mínimo de la columna seleccionada
        const deductible = item?.deductibles?.find(d => d.id === item.selectedDeductible?.deductible_id);
        const notEmptyOrDisabled = deductible.premiums.filter(p => p.col_order === item.selectedDeductible?.col_order && !p.is_disabled && (p.price_monthly > 0 || p.price_annual > 0));
        const minPremium = notEmptyOrDisabled?.map(p => {
          return parseFloat(parseFloat(p.price_monthly) > 0 ? p.price_monthly : p.price_annual);
        });
        return Math.min(...minPremium);
      }
      return 0;

    } else {
      // Busca el monto mínimo del precio seleccionado
      const price = (item?.prices || [])?.find(x => x.id === item?.selectedPriceId);
      return price?.price_monthly || price?.price_annual || 0;
    }
  }

  const removeItem = (productIdx) => {
    const others = cart.filter((_,i) => i !== productIdx);
    dispatch({ type: 'SET_CART', payload: others });
  }

  const submit = async () => {
    onClose();
    history.push('/mi-pedido/beneficiarios');
  }

  return {
    cart,
    getPrice,
    removeItem,
    submit,
  }
}

export default Cart